import {toast} from 'react-toastify';
import {CloseIcon, CopyIcon, SaveIcon} from '../../ui-components/Iconpack';
import {Button} from '../../ui-components/Button/button';
import React from 'react';
import tracker from '../../lib/analytics/tracker';
import {EventNames} from '../../lib/analytics/events';

interface TransformationHeaderProps {
    isEmbedded: boolean;
    modifiedCdnUrl: string;
    cdnUrl: string;
    saveImage: () => void;
    handleCloseButton: () => void;
}

export default function TransformationHeader({
    isEmbedded,
    modifiedCdnUrl,
    cdnUrl,
    saveImage,
    handleCloseButton,
}: TransformationHeaderProps) {
    return (
        <div className='hidden justify-between border border-transparent border-b-[#333333] px-5 py-3 md:flex'>
            <div className='flex items-center justify-center rounded-[8px] bg-[#293056]'>
                <input
                    type='text'
                    className='rounded-[8px] bg-[#293056] px-[14px] py-[5px] text-[14px] font-[500] text-[#FFFFFF] md:w-[637px]'
                    value={`Image URL: ${modifiedCdnUrl.length > 0 ? modifiedCdnUrl : cdnUrl}`}
                    disabled
                />
                <div
                    className='cursor-pointer pr-3'
                    onClick={() => {
                        navigator.clipboard.writeText(modifiedCdnUrl.length > 0 ? modifiedCdnUrl : cdnUrl).then(() => {
                            tracker.trackEvent(EventNames.IMAGE_COPIED);
                            toast.success('Image Url Copied!');
                        });
                    }}>
                    <CopyIcon width={20} height={20} color={'#FFFFFF'} />
                </div>
            </div>
            <div className='flex justify-end'>
                <div className='flex items-center justify-between gap-2'>
                    <Button
                        className='text-[14px] font-[600] text-[#FFFFFF]'
                        variant='primary'
                        size='sm'
                        icon
                        onClick={saveImage}>
                        <SaveIcon />
                        Save Image
                    </Button>
                    {!isEmbedded && (
                        <Button
                            className='text-[14px] font-[600] text-[#262626]'
                            variant='secondary'
                            size='sm'
                            onClick={handleCloseButton}>
                            <CloseIcon />
                            Close
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}
